import { useTranslation } from "react-i18next";
import {
    TEXT_FIELD_TYPE,
    DATE_RANGE_FIELD_TYPE,
    BOOLEAN_FIELD_TYPE
} from "../../helpers/constants";

import SelectFieldService from "../../services/selectFieldService";
import DateService from "../../services/dateService";

export const CLAUSE_TABLE_NAME = "clause_history_table";

export const useClauseTableFieldsConfig = () => {
    const { t } = useTranslation();

    return [
        {
            name: "persclau_person_full_name",
            other_export_field_name: "persclau_person",
            getValueCallback: (rowData) => rowData.persclau_person,
            label: t("clients.PersonClausesDialog.table.persclau_person"),
            filterType: TEXT_FIELD_TYPE,
            headerSx: { whiteSpace: "break-spaces" },
        },
        {
            name: "email",
            getValueCallback: (rowData) => rowData.email,
            label: t("clients.PersonClausesDialog.table.email"),
            filterType: TEXT_FIELD_TYPE,
            headerSx: { whiteSpace: "break-spaces" },
        },
        {
            name: "phone",
            getValueCallback: (rowData) => rowData.phone,
            label: t("clients.PersonClausesDialog.table.phone"),
            filterType: TEXT_FIELD_TYPE,
            headerSx: { whiteSpace: "break-spaces" },
        },
        {
            name: "clause_name",
            getValueCallback: (rowData) => rowData.clause_name,
            label: t("clients.PersonClausesDialog.table.clause_name"),
            filterType: TEXT_FIELD_TYPE,
            headerSx: { whiteSpace: "break-spaces" },
        },
        {
            name: "persclau_text",
            getValueCallback: (rowData) => rowData.persclau_text,
            label: t("clients.PersonClausesDialog.table.persclau_text"),
            filterType: TEXT_FIELD_TYPE,
            headerSx: { whiteSpace: "break-spaces" },
        },
        {
            name: "persclau_decision",
            getValueCallback: (rowData) => SelectFieldService.getLabelOptionsYesOrNo(rowData.persclau_decision),
            label: t("clients.PersonClausesDialog.table.persclau_decision"),
            filterType: BOOLEAN_FIELD_TYPE,
            headerSx: { whiteSpace: "break-spaces" },
        },
        {
            name: "creator_full_name",
            other_export_field_name: "creator",
            getValueCallback: (rowData) => rowData.creator,
            label: t("clients.PersonClausesDialog.table.creator"),
            filterType: TEXT_FIELD_TYPE,
            headerSx: { whiteSpace: "break-spaces" },
        },
        {
            name: "persclau_comment",
            getValueCallback: (rowData) => rowData.persclau_comment,
            label: t("clients.PersonClausesDialog.table.persclau_comment"),
            filterType: TEXT_FIELD_TYPE,
            headerSx: { whiteSpace: "break-spaces" },
        },
        {
            name: "created",
            getValueCallback: (rowData) => DateService.convertDatetimeFromBackendToFormatYYYYMMDD_hhmmss(rowData.created),
            label: t("clients.PersonClausesDialog.table.created"),
            filterType: DATE_RANGE_FIELD_TYPE,
            getFilterFieldConfigCallback: (filteringData) => ({
                style: { minWidth: "100px" },
            }),
            sortable: true,
        },
    ];
};
